import { useSelector } from "react-redux";
import { RootState } from "../../redux-store";
import Loader from "Containers/NewOrder/Loader";

export function GlobalLoader() {
  const isLoading = useSelector(
    (state: RootState) => state.globalLoaderReducer.activeRequests > 0,
  );

  if (!isLoading) return null;

  return (
    <Loader />
  );
}
